"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _architectMixins = require("@wealthmigrate/architect-mixins");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-CONTAINERS [ CARDS CONTAINER > STYLE ] ############################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. STYLES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. MAIN CONTAINER .........................................................


var GridContainer = _styledComponents["default"].div.withConfig({
  displayName: "indexstyle__GridContainer",
  componentId: "sc-179tzhm-0"
})(["display:grid;grid-gap:var(--gutter-medium);grid-template-columns:1fr 1fr 1fr;@media ", "{grid-gap:var(--gutter-small);grid-template-columns:1fr;};@media ", "{grid-gap:var(--gutter);grid-template-columns:1fr 1fr;};@media ", "{grid-gap:var(--gutter);grid-template-columns:1fr 1fr 1fr;};@media ", "{};"], _architectMixins._mixin_device.s, _architectMixins._mixin_device.m, _architectMixins._mixin_device.l, _architectMixins._mixin_device.xl); // 3.1. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports.GridContainer = GridContainer;